import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function SofiaCristandoPage() {
  return <AttorneyBioTemplate attorney={attorneys['sofia-cristando-esq']} />;
}
